var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userRole !== 'guest')?_c('div',[_c('button',{staticClass:"btn btnFull btnPrimary",attrs:{"type":"button"},on:{"click":_vm.onSave}},[_vm._v(_vm._s(_vm.locale.save))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }